import { Component, ChangeDetectionStrategy, inject, Input } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-auth-header',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="header-container">
      @if (showBackButton) {
        <div class="back-link">
          <a (click)="goBack()" style="cursor: pointer; color: oklch(51% 0.28 263.83); font-size: 0.875rem;">← Zurück</a>
        </div>
      }
      <div class="header-content">
        <div (click)="goHome()" style="cursor: pointer;">
          <h1>ProTyco</h1>
          <p style="text-align: center; margin: 0.25rem 0 0 0;">
            <span style="color: oklch(51% 0.28 263.83);">PRO</span>PERTY <span style="color: oklch(51% 0.28 263.83);">TYCO</span>ON
          </p>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .header-container {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      background: white;
      color: white;
      padding: 1rem 2rem 1rem 2rem;
      margin: 0;
      border-radius: 0;
      box-shadow: none;
      border-bottom: 1px solid #d1d5db;
      position: relative;
      z-index: 10;
      overflow: visible;
      box-sizing: border-box;
    }

    .header-container::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 1px;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
      pointer-events: none;
    }

    .header-content {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      text-align: center;
      position: relative;
      overflow: visible;
      user-select: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      pointer-events: none;
    }

    .header-content > div {
      flex: 0 1 auto;
      overflow: visible;
      width: fit-content;
      margin: 0 auto;
    }

    .header-content > div > * {
      pointer-events: auto;
    }

    .header-content::before {
      content: '';
      position: absolute;
      top: -15px;
      left: 50%;
      transform: translateX(-50%);
      width: 80px;
      height: 40px;
      background: linear-gradient(135deg, oklch(60% 0.3 280) 0%, oklch(45% 0.28 263.83) 100%);
      border-radius: 50%;
      opacity: 0.1;
      filter: blur(20px);
      z-index: 0;
    }

    .header-content h1 {
      background: linear-gradient(135deg, oklch(45% 0.28 263.83) 0%, oklch(60% 0.3 280) 50%, oklch(45% 0.28 263.83) 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      font-size: 3rem;
      margin: 0;
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
      font-weight: 900;
      letter-spacing: 0px;
      position: absolute;
      top: -32px;
      left: 50%;
      transform: translateX(calc(-50% + 7px));
      white-space: nowrap;
      user-select: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
    }

    .header-content p {
      color: oklch(28% 0.06 263.83);
      margin: 43px 0 0 15px !important;
      padding-bottom: 0rem;
      font-weight: 600;
      font-size: 0.875rem;
      letter-spacing: 1px;
      text-transform: uppercase;
      line-height: 1.4;
      user-select: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
    }

    .header-content p span {
      position: relative;
    }

    .back-link {
      padding-top: 0.25rem;
    }

    .back-link a {
      text-decoration: none;
      transition: all 0.2s;
      white-space: nowrap;
      display: inline-block;
      overflow: visible;
      pointer-events: auto;
      position: relative;
      left: -32px;
    }

    .back-link a:hover {
      opacity: 0.8;
      text-decoration: underline;
    }

    /* ============ RESPONSIVE ============ */
    @media (max-width: 768px) {
      .header-content h1 {
        font-size: 2rem;
        padding-top: 1rem;
      }

      .header-content p {
        font-size: 0.5625rem;
        margin: 32px 0 0 15px !important;
      }
    }

    @media (max-width: 480px) {
      .header-content h1 {
        font-size: 2rem;
        padding-top: 1rem;
      }

      .header-content p {
        font-size: 0.5625rem;
        margin: 32px 0 0 15px !important;
      }
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthHeaderComponent {
  private router = inject(Router);
  private location = inject(Location);

  @Input() showBackButton = false;

  goBack() {
    this.location.back();
  }

  goHome() {
    this.router.navigate(['/']);
  }
}
